<template>
	<div id="indexpage" v-title :data-title="title" style="height:100%;">
		<!-- <headerbar msg="chanyednao" :curindex="false"> </headerbar> -->
		
		<!-- 弹框 -->
			<el-drawer
			  title="我是标题"
			  :visible.sync="drawer"
			  :with-header="false" 
						:direction='direction2'
						:modal-append-to-body="modal"
					size='350px'> 
					  <bottomnav :activepage='14'></bottomnav> 
			</el-drawer> 
			<el-drawer
			  title="我是标题"
			  :visible.sync="drawer2"
			  :with-header="false" 
						:direction='direction'
						size='240px'
						:modal-append-to-body="modal"> 
					  <leftnav :isCollapse='isCollapse' :activenav='"3-4"'  :curindex='4'></leftnav>
			</el-drawer> 
			<span class="screen" @click="drawer2 = true"  ><i class="el-icon-s-unfold"></i>菜单栏</span> 
		<!-- 弹框 -->	
		
		<div class="por" style="background-color: #041034;height:100%;">
			<div class="index-swiper centerpage">
				<h2 class="title dataswipertitle"  @click="drawer = true">{{userdata.cityText}}{{title}}<i class="el-icon-arrow-down dataswipertitle_icon"></i></h2>
				<div class="indexflex qxzhswiper">
					 <div class="col3  qxzh_left">
							<div class="qxzh_left_top transparentbg">
							<h3 class="swiper_title">区县介绍</h3>
							<div class="qxzh_introduce"> 
									<vue-seamless-scroll :data="colors"  :class-option="defaultOption2">
										<p>泰州，简称“泰”，古称海陵，是江苏省辖地级市，长江三角洲中心区27城之一  ，国务院批复确定的中国长江三角洲地区重要的工贸港口城市。截至2018年，全市下辖3个区、代管3个县级市。  总面积5787平方公里   。根据第七次人口普查数据，截至2020年11月1日零时，泰州市常住人口为451.2762万人。2020年，泰州市实现地区生产总值5312.77亿元，同比增长3.6%。</p>
										<p>泰州地处中国华东地区、江苏中部，是扬子江城市群重要组成部分，南濒长江、北邻盐城、东临南通、西接扬州，是承南启北的水陆要津，为苏中门户，自古有“水陆要津，咽喉据郡”之称。700多年前，马可·波罗游历泰州，称赞“这城不很大，但各种尘世的幸福极多”。 </p>
										<p>泰州是国家历史文化名城，秦称海阳，汉称海陵，州建南唐，文昌北宋。南唐时（公元937年）为州治，取“国泰民安”之意，始名泰州。泰州人文荟萃、名贤辈出，王艮、刘熙载、施耐庵、郑板桥、梅兰芳是泰州文化艺术史上的杰出代表。 </p>
										<p>泰州所辖县市（区）全部建成国家级生态示范区、全国百强县，同时泰州也是全国文明城市  、国家环保模范城市   、国家园林城市、中国优秀旅游城市、全国科技进步先进市、第一批国家农业可持续发展试验示范区。</p>
										<p>2017年中国地级市全面小康指数排名第42  。2018年11月，入选中国城市全面小康指数前100名。   12月，被评为2018中国大陆最佳商业城市100强。2020年10月9日，被生态环境部授予第四批国家生态文明建设示范市县称号。2020年10月，被评为全国双拥模范城（县）。</p>
									</vue-seamless-scroll>
								</div>
							</div>
							<div class="qxzh_left_bottom transparentbg">
							<h3 class="swiper_title">工业总产值</h3> 
							<div id="qxzh_zcz"></div>
							</div>
						</div>
						<div class="col4  qxzh_center">
							<div class="qxzh_center_top">
								<div class="qxzh_mapbox">
									<div id="qxzh_map"></div>
									<ul class="flexcss">
										<li v-show="endVal1>0">
											<h4 class="title">GDP</h4>
											<p><countTo :startVal="1000" :endVal='endVal1' class="orangefont" :decimals="2" :props="contodefault"></countTo><span class="ltqy_until">亿元</span></p> 
										</li>
										<li v-show="endVal2>0">
										<h4 class="title" >土地面积</h4>
											<p><countTo :startVal="1000" :endVal='endVal2' class="orangefont" :decimals="2" :props="contodefault"></countTo><span class="ltqy_until">km²</span></p> 
										</li>
										<li v-show="endVal3>0">
										<h4 class="title">建成区面积</h4>
											<p><countTo :startVal="1000" :endVal='endVal3' class="orangefont" :decimals="2" :props="contodefault" ></countTo><span class="ltqy_until">km²</span></p> 
										</li>
									</ul>
								</div>
								
							</div>
							<div class="qxzh_center_bottom transparentbg">
								<h3 class="swiper_title">近五年产业用地成交面积（亩）</h3>
								<div id="qxzh_area"></div>
							</div>
						</div>
						<div class="col3  qxzh_right">
						 <div class="qxzh_right_top transparentbg">
						 <h3 class="swiper_title">主导产业值（亿元）</h3> 
							<div id="qxzh_zdcy"></div>
						 </div>
							<div class="qxzh_right_center transparentbg">
							<h3 class="swiper_title">各区重点企业</h3>
								<div class="qxzh_left_tabbox">
								<div class="thbox">
									<ul class="flexcss"> 
										<li class="th_list1">企业名称</li>
										<li class="th_list2">所属产业</li>
										<li class="th_list2">营收（亿元）</li>  
										</ul> 
										</div>
										<div class="qxzh_scrollbox">
										<vue-seamless-scroll :data="enterpriselist"  :class-option="defaultOption" >   <!-- :data="colors"  :class-option="defaultOption" -->
											<ul class="qxzh_tab flexcss " v-for="item in enterpriselist">   
												<li class="th_list1">{{item.name}}</li>		
												<li class="th_list2">{{item.industry}}</li>
												<li class="th_list2">{{item.revenue}}</li>  
												</ul> 	 
									</vue-seamless-scroll >
								</div>
									</div>
							</div>
							<div class="qxzh_right_bottom transparentbg">
							<h3 class="swiper_title">劳动力人口数量</h3>
								<div id="qxzh_rk"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import mappng from '../../../assets/images/mapbg.png';
	export default {
		name: 'quxianzonghe',
		data() {
			return {
				isCollapse:false,
				isFullscreen: false,
				direction:"ltr",  //btt
				direction2:"btt",  //btt
				 drawer: false,
					drawer2: false,
					modal:false,	
				title: "各区县综合大屏",
				bgcolor: "#041034",
				startVal: 0, //数字滚动开始值
				endVal1: 1000, //GDP数字滚动结束 
				endVal2: 1000, //土地面积数字滚动结束
				endVal3: 1000, //建设面积数字滚动结束
				usernotionlistsave: [],
				userdata: {}, 
				clynav:1,
				clychartnav:1,
				mapurl: 'map/city/321200.json',
				contodefault: {
					duration: 1000,
					autoplay: true,
				},
				islogin: false,
				flag: true,
				swipernum: 3, 
				zoom: 13,
				public_tooltip: {
					trigger: 'axis',
					backgroundColor: 'rgba(255,255,255,0.9)',
					borderColor: '#ddd',
					borderWidth: '1',
					textStyle: {
						color: '#000',
						fontSize: 14,
					}
				},
				mapurl: 'map/city/321200.json',
				colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"],
				landType: [],
				startCharts: null,
				//假数据 
						fixassetsdata:[{name:"泰兴市",value:101},{name:"靖江市",value:120},{name:"兴华市",value:130},{name:"姜堰区",value:176},{name:"高港区",value:187},{name:"海陵区",value:201}], 
						zdcydata:[{name:"第一产业",value:203.31	},{name:"第二产业",value:482.27},{name:"第三产业",value:344.02}],
						ydata:[
											{name: "高港区", 	value: 1432}, 
											{name: "泰兴市", value: 1253}, 
											{	name: "海陵区",value: 1104},
											{name: "靖江市",value: 991},
											{name: "兴化市",value: 593},
											{name: "姜堰市",	value: 460},
											],	
						areadata:[
											{name: "2016", 	value: 1432}, 
											{name: "2017", value: 1253}, 
											{	name: "2018",value: 1104},
											{name: "2019",value: 991},
											{name: "2020",value: 593},
											{name: "2021",	value: 460},
											],
					enterpriselist:[
						{name: "江苏太平洋精锻科技股份有限公司",	industry: "金属铸造",revenue:11.64},
						{name: "江苏扬电科技股份有限公司",	industry: "变压器",revenue:4.31},
						{name: "江苏锦鸡实业股份有限公司",	industry: "染料",revenue:7.52},
						{name: "江苏森萱医药股份有限公司",	industry: "医药制造",revenue:5.45},
						{name: "江苏宝馨科技股份有限公司",	industry: "钣金件",revenue:4.73},
						{name: "江苏东华测试技术股份有限公司",	industry: "仪器仪表",revenue:1.96},
						{name: "江苏亚星锚链股份有限公司",	industry: "金属铸造",revenue:11.64},
						{name: "江苏万林现代物流股份有限公司",	industry: "交通运输/仓储和邮政业",revenue:7.19},
						{name: "华达汽车科技股份有限公司",	industry: "汽车制造",revenue:39.76},
						{name: "双乐颜料股份有限公司",	industry: "颜料与染料",revenue:13.53},
					],
			}
		},
		props: {
			msg: String,
		},
		computed: {
			defaultOption() {
				return {
					step: 0.7, // 数值越大速度滚动越快
					limitMoveNum: this.enterpriselist.length, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			},
			defaultOption2() {
				return {
					step: 0.7, // 数值越大速度滚动越快
					limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
					hoverStop: true, // 是否开启鼠标悬停stop
					direction: 1, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
				}
			}
		},
		mounted() {
			document.getElementById('app').style.background = this.bgcolor;
			this.userdata = this.getuseriformation();
			// console.log(this.userdata); 
				this.fixassetsFun('qxzh_zcz',this.fixassetsdata);
				this.chart1Fun('qxzh_zdcy',this.zdcydata);
				this.seasongdpFun('qxzh_rk',this.fixassetsdata);
				this.mapGeo('qxzh_map',this.ydata);
				this.TaxchartFun();
		},
		methods: { 
			//工业总产值
			fixassetsFun(el,data){ 
				var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
				var chart = echarts.init(document.getElementById(el)); 
				var _this = this,xline=[],seriesline=[]; 
				// var datalen=data.length-1;
				for(var i=0;i<data.length;i++){
					xline.push(data[i].name);
					seriesline.push(data[i].value);
				}; 
				var option = {
					title:{
						text:"",left:25,top:20, textStyle:{color:'#eee',fontSize:16}
					},
					tooltip:{
						show:false,
						trigger: 'axis',
						backgroundColor: 'rgba(255,255,255,0.9)',
						borderColor: '#ddd',
						borderWidth: '1',
						textStyle: {
							color: '#000',
							fontSize: 14,
						},
						formatter: '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff"></span>'+'内容：'+'{c}'
						},
					color: _this.colors,
					grid: { x: 78, 	y: 10, x2: 50, y2: 0, show: true, 	borderWidth: 0,},
					label: { show: true, position: 'inside', valueAnimation: true ,color:'#fff',formatter: '{@score}'+'亿元'},
					xAxis: {	type: 'value',axisTick:{show:false},boundaryGap: [0, 0.01],splitLine:{show:false},axisLabel : {formatter: function(){ return "";}}},
					yAxis: { type: 'category',splitLine:{show:false},axisTick:{show:false},axisLine: {show:false},data: xline,axisLabel:{fontSize: 13,color:'#eee'}},
					series: [{ data: seriesline, type: 'bar', barWidth:20,itemStyle: { normal: { color: '#5b8ff9', } }, }]
				};
				chart.setOption(option);   
			}, 
			
			//主导产业值（亿元）
				chart1Fun(el,data) {
							var chart1 = echarts.init(document.getElementById(el));
							var _this = this;
							// for(var i=0;i<data.length;i++){
							// 	 data[i].name = data[i].text;
							// }
							// console.log('data',data);
							var option = {
								tooltip: {},
								series: [{
									type: 'treemap',
									nodeClick: 'false',  //点击节点不反应 
									roam:'false',  //不能缩放平移
									itemStyle:{
										// borderWidth:"1"
										gapWidth:'1'  //图像间的间隔
									},
									emphasis:{
										focus: 'self',   //聚焦当前数据
										// blurScope: 'coordinateSystem'
									},
									breadcrumb: { show: false},
									data: data,
								}]
							};
							chart1.setOption(option);
						},
						
						//劳动力人口数量
						seasongdpFun(el,data){
							var  seasongdp= echarts.init(document.getElementById(el)); 
							var _this = this,xdata=[],ydata=[];
							for(var i=0;i<data.length;i++){
								xdata.push(data[i].name);
								ydata.push(data[i].value); 
							}
							var 	option = {
							  tooltip: {
							    trigger: 'axis',  
							  }, 
							  legend: {show:false, },
									grid:{  x:40, y:20, x2:40,y2:40 },
									
							  xAxis: [
							    {
							      type: 'category',
							      data: xdata,
							      axisPointer: {
							        type: 'shadow'
							      },
													axisLine: {
														show:false,
													lineStyle:{
														color:'#eee',
													}, 
													},
													axisTick:{"show":false },
							    }
							  ],
							  yAxis: [
							    {
							      type: 'value',
							      name: ' ',  
							      axisTick:{"show":false },
													axisLine: {
														show:false,
													lineStyle:{
														color:'#eee',
													}
													},   
													splitLine:{show:false}, //不显示分割线
													axisLabel : {
													            formatter: function(){   //不显示y轴数据
													                return "";
													            }
													        }
							    },  
							  ],
							  series: [ 
							    {
							      name: 'GDP（亿元）',
							      type: 'bar',
													barWidth:40,
													color:'#1890ff',
													label:{ 							//图表顶部显示数据
													  normal:{ 
													  show: true, 
													  position: 'top',			//显示位置顶部
															color : '#fff',				//文字颜色
															formatter: '{@score}'+'万人',
													   }
													},
							      data:ydata,
							    }, 
							  ]
							};
							seasongdp.setOption(option);  
						},
						
						
			//近五年产业用地成交面积（亩） 
			TaxchartFun(){
			var charPie3currentIndex = 0,isSet = true;//为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var  Taxchart= echarts.init(document.getElementById('qxzh_area')); 
			var 	option = {
			  tooltip: {
						show:true,
			    trigger: 'item',   
						// formatter:"<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{a}：{c}"
			  },   
			  legend: {show:false,top: '5%',right:'5%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:8,itemHeight:8, },	  
					grid:{  x:'15%', y:'15%', x2:'10%',y2:'15%' },
			  xAxis: [
			    {
			      type: 'category',
			      data: ['2016年', '2017年', '2018年', '2019年', '2020年'],
			      axisPointer: {
			        type: 'shadow'
			      },
									axisLine: {
										show:true,
									lineStyle:{
										color:'#eee',
									}
									},
									axisLabel:{}
			    }
			  ],
			  yAxis: [
			    { 
			      type: 'value',
			      name: '',
			      // min: 0,
			      // max: 60,  
			      axisTick:{"show":true },		//刻度线
									axisLine: {														//轴线
										show:true,
									lineStyle:{
										color:'#eee',
									}
									},  
									splitLine:{show:false}, //不显示网格线
			    }, 
			  ],
			  series: [
    {
      name: '海陵区',
      type: 'line',
      stack: 'Total',
						symbol:'circle', //拐点样式
						symbolSize: 10,//拐点大小
						 itemStyle : {  
						     normal : {  
						     lineStyle:{  
													color:'rgba(0,0,0,0)'  
						           }  
						       }  
						     },
      data: [120, 132, 101, 134, 90, 230, 210]
    },
    {
      name: '高港区',
      type: 'line',
      stack: 'Total',
						symbol:'circle',  //拐点样式
						symbolSize: 15,//拐点大小
						 itemStyle : {  
						     normal : {  
						     lineStyle:{  
													color:'rgba(0,0,0,0)'  
						           }  
						       }  
						     },
      data: [220, 182, 191, 234, 290, 330, 310]
    },
    {
      name: '姜堰市',
      type: 'line',
      stack: 'Total',
						symbol:'circle',//拐点样式
						symbolSize: 20,//拐点大小
						 itemStyle : {  
						     normal : {  
						     lineStyle:{  
													color:'rgba(0,0,0,0)'  
						           }  
						       }  
						     },
      data: [150, 232, 201, 154, 190, 330, 410]
    },
    {
      name: '兴华市',
      type: 'line',
      stack: 'Total',
						symbol:'circle',//拐点样式
						symbolSize: 25,//拐点大小
						 itemStyle : {  
						     normal : {  
						     lineStyle:{  
													color:'rgba(0,0,0,0)'  
						           }  
						       }  
						     },
      data: [320, 332, 301, 334, 390, 330, 320]
    },
    {
      name: '泰兴市',
      type: 'line',
      stack: 'Total',
						symbol:'circle',//拐点样式
						symbolSize: 30,//拐点大小
						 itemStyle : {  
						     normal : {  
						     lineStyle:{  
													color:'rgba(0,0,0,0)'  
						           }  
						       }  
						     },
      data: [150, 250, 311, 410, 320, 330, 320]
    },
				{
				  name: '靖江市',
				  type: 'line',
				  stack: 'Total',
						symbol:'circle',//拐点样式
						symbolSize:35,//拐点大小
						 itemStyle : {  
						     normal : {  
						     lineStyle:{  
													color:'rgba(0,0,0,0)'  
						           }  
						       }  
						     },
				  data: [150, 250, 311, 410, 320, 330, 320]
				}
  ]
					 
			};
			Taxchart.setOption(option); 
		 
		},
						
						
						
						
						//地图
						mapGeo(el, data) {
										var myChart = echarts.init(document.getElementById(el));
										var mapUrl = this.mapurl;
										var _this = this;
										// console.log(data);
										var tootlips=this.public_tooltip; 
										$.getJSON(mapUrl, function(geoJson) {
											echarts.registerMap('taizhou', geoJson);
											myChart.hideLoading(); 
											var option = {
												backgroundColor: 'rgba(0,0,0,0)',
												title: {
													text: '',
													subtext: '',
													left: 20,
													bottom:130,
													textStyle: {
														color: '#fff',
														fontWeight: 700,
														fontSize: 18,
													},
												}, 
												// grid: {
												// 		        left: '3%',
												// 		        right: '4%',
												// 		        bottom: '3%',
												// 		        containLabel: true
												// 		    },
												tooltip:{
													alwaysShowContent: true,
													show: false,
													hoverAnimation: true,
													trigger: 'item', //触发类型 散点图
													enterable: true, //鼠标是否可进入提示框
													transitionDuration: 1, //提示框移动动画过渡时间
													// triggerOn: 'click',
													borderWidth: '1px',
													borderRadius: '4',
													borderColor: '#00B2AC',
													backgroundColor: "rgba(0,0,0,.8)",
													textStyle: {
														color: '#fff'
													}, 
													formatter:function(parms){
														return "<h4 class='oh'><span class='fl'>地区</span><span class='fr'>"+parms.name+"</span></h4><div class='oh'><span class='fl'>新增企业</span><span class='fr'>"+parms.value+"</span></div>";
													}
												},
												geo: {
													map: 'taizhou',
													aspectScale:0.8,
													layoutCenter: ['50%', '50.5%'],
													layoutSize: '100%',
													silent: true,
													roam: false,
													z: 0,
													itemStyle: {
														normal: {
															areaColor: 'rgba(255,0,0,0)', //地图背景阴影
															shadowColor: 'rgba(0, 0, 0, 1)',
															shadowBlur: 0,
															shadowOffsetX: 0,
															shadowOffsetY: 1,
															borderColor: 'rgba(0, 0, 0, 0.7)',
															borderWidth: 0.5,
														},
														emphasis: {
															areaColor: 'rgba(0,0,0,0)',
															borderWidth: 1,
															color: 'green',
															label: {
																show: true,
															},
														},
													},
												},
												series: [
													{
													type: 'map',
													zoom: 1.1, 
													aspectScale: 0.9, //地图的长宽比
													// roam: false,
													map: 'taizhou',
													roam: false,
													data:data,
													label: {
														normal: {
															show: true,
															rotate:90,
															textStyle: {
																fontSize: 14,
																color: '#fff',
															},
														},
														emphasis: {
															textStyle: {
																color: '#fff',
															},
														},
													},
													itemStyle: {
														normal: {
															borderColor: '#6185be',
															borderWidth: 1,
															// areaColor: {
															// 	image: mappng,
															// 	repeat: 'repeat',
															// },
															areaColor:"#045c99",
															shadowColor: '#96aece',
															shadowBlur: 0,
															shadowOffsetX: 0,
															shadowOffsetY: 1,
														},
														emphasis: {
															// areaColor: {
															// 	image: '#f60',
															// 	repeat: 'repeat',
															// },
															areaColor:"#023e64",
															borderColor: '#ccc',
															borderWidth: 1,
															shadowColor: '#96aece',
															shadowBlur: 10,
															shadowOffsetX: 2,
															shadowOffsetY: 1,
															label: {
																show: true,
															},
														},
													},
													
												},  
												],
											};
											myChart.setOption(option);
										});
										// 地图点击事件
										myChart.on('click', function(params) {
											console.log('selected',params.event.target.selected);
											//判断该市是否选中，true则改变该市的数据，false则显示默认数据
											if(params.event.target.selected){
											if(params.name=="泰兴市"){
												_this.endVal1=1127.47;  //数字滚动结束值
											_this.endVal2= 1170;  //数字滚动结束值
											_this.endVal3=44.31;  //数字滚动结束值 
											}else if(params.name=="兴化市"){
												_this.endVal1=900.92;  //数字滚动结束值
													_this.endVal2= 2395;  //数字滚动结束值
													_this.endVal3=43;  //数字滚动结束值 
											}else if(params.name=="姜堰市"){
												_this.endVal1=687.49;  //数字滚动结束值
													_this.endVal2= 928;  //数字滚动结束值
													_this.endVal3=34.82;  //数字滚动结束值 
											}
											else if(params.name=="靖江市"){
												_this.endVal1=1004.8;  //数字滚动结束值
													_this.endVal2= 656;  //数字滚动结束值
													_this.endVal3=33.98;  //数字滚动结束值 
											}	else if(params.name=="高港区"){
												_this.endVal1=634.97;  //数字滚动结束值
													_this.endVal2= 334;  //数字滚动结束值
													_this.endVal3=0;  //数字滚动结束值 
											}
											else if(params.name=="海陵区"){
												_this.endVal1=620.19;  //数字滚动结束值
													_this.endVal2= 305;  //数字滚动结束值
													_this.endVal3=0;  //数字滚动结束值 
											} 
											}else{
												_this.endVal1=4975.84;
													_this.endVal2=	5788;
														_this.endVal3 =	156.11;
											}
											
											
											console.log(params);
										});
									},
						
 		}
	}
</script>

<style scoped="scoped"> 
</style>
